import axios from '../../../../utills/axiosConfig';


export const fetchPermissions = async () => {
  const res = await axios.get('/permissions');
  return res.data;
};

export const addPermission = async (permission) => {
  const res = await axios.post('/permissions', permission);
  return res.data;
};

export const updatePermission = async (id, permission) => {
  const res = await axios.put(`/permissions/${id}`, permission);
  return res.data;
};

export const deletePermission = async (id) => {
  const res = await axios.delete(`/permissions/${id}`);
  return res.data;
}; 